import type { SettingsTranslations } from "../../types/settings";

export const settings: SettingsTranslations = {
  title: "Kasutaja seaded",
  security: "Turvalisus",
  organizationTitle: "Organisatsiooni seaded",
  organizationSubtitle: "Hallake oma organisatsiooni andmeid.",
  userManagementSubtitle: "Kutsuge kasutajaid ja hallake nende rolle.",
  usage: {
    title: "Kasutus",
    subtitle: "Salvestusruumi kasutus sinu hoonetes ja projektides.",
    used: "kasutatud",
    of: "/",
    near: "Salvestusruum peaaegu täis",
    full: "Salvestusruum täis",
    unlimited: "Piiramatu",
    byProject: "Salvestusruum projektide kaupa",
    noProjects: "Nähtavaid projekte pole.",
    shared:
      "Projektide vahel jagatud failid arvestatakse igas projektis; hoone kogumahus ainult üks kord.",
    loading: "Salvestusruumi kasutuse laadimine…",
    loadError: "Salvestusruumi kasutust ei õnnestunud laadida. Proovi värskendades uuesti.",
    retry: "Proovi uuesti",
    empty: "Selles organisatsioonis pole ligipääsetavaid hooneid.",
  },
  general: "\u00DCldine",
  languageEnglish: "English",
  languageEstonian: "Eesti",
  organization: {
    details: "Organisatsiooni andmed",
    logo: "Organisatsiooni logo",
    logoDescription: "Kuvatakse organisatsioonide vahetajas ja teie saadetud kutsete e-kirjades.",
    logoEmpty: "Laadige \u00FCles oma organisatsiooni logo.",
    uploadLogo: "Laadi logo \u00FCles",
    replaceLogo: "Vaheta logo",
    removeLogo: "Eemalda logo",
    logoUploaded: "Organisatsiooni logo uuendatud",
    logoRemoved: "Organisatsiooni logo eemaldatud",
    logoTooLarge: "Pilt peab olema kuni 2 MB",
    logoInvalidType: "Lubatud on ainult PNG-, JPEG- v\u00F5i WebP-pildid",
    logoUploadFailed:
      "Organisatsiooni logo \u00FCleslaadimine eba\u00F5nnestus. Palun proovige uuesti.",
  },
  personal: {
    title: "Isikuandmed",
    description: "Uuendage oma isikuandmeid ja konto seadeid.",
    basicInfo: "P\u00F5hiandmed",
    contactInfo: "Kontaktandmed",
    professionalInfo: "Ametialane info",
    firstName: "Eesnimi",
    lastName: "Perekonnanimi",
    email: "E-post",
    phone: "Telefoninumber",
    phonePlaceholder: "+372 5123 4567",
    jobTitle: "Ametinimetus",
    jobTitlePlaceholder: "nt Vaneminsener",
    company: "Ettev\u00F5te",
    companyPlaceholder: "nt Acme O\u00DC",
    profileUpdated: "Profiil uuendatud",
    profileUpdatedDesc: "Teie profiil on edukalt uuendatud.",
    updateFailed: "Uuendamine eba\u00F5nnestus",
    updateFailedDesc: "Profiili uuendamine eba\u00F5nnestus. Palun proovige uuesti.",
    notAuthenticated: "Kasutaja pole autenditud",
    profileNotLoaded: "Profiili ei laaditud. Palun laadige leht uuesti.",
    namesRequired: "Eesnimi ja perekonnanimi on n\u00F5utud",
    profilePicture: "Profiilipilt",
    editProfilePicture: "Lae \u00FCles",
    removeProfilePicture: "Eemalda foto",
    profilePictureUploaded: "Profiilipilt uuendatud",
    profilePictureRemoved: "Profiilipilt eemaldatud",
    profilePictureTooLarge: "Pilt peab olema kuni 2 MB",
    profilePictureInvalidType: "Lubatud on ainult PNG, JPEG v\u00F5i WebP pildid",
    profilePictureUploadFailed:
      "Profiilipildi \u00FCleslaadimine eba\u00F5nnestus. Palun proovige uuesti.",
    cropTitle: "Kohanda pilti",
    cropDescription: "Lohista paigutamiseks ja kasuta liugurit suurendamiseks.",
    cropZoom: "Suurendus",
    cropSave: "Salvesta",
    cropCancel: "T\u00FChista",
    avatarColor: "Avatari v\u00E4rv",
    avatarColorDescription: "Vali oma initsiaalide avatari v\u00E4rv, kui sul pole profiilipilti.",
    customColor: "Kohandatud v\u00E4rv",
    customColorPlaceholder: "#ef4129",
    pickCustomColor: "Vali kohandatud v\u00E4rv",
    colorPickerHexLabel: "Heksav\u00E4rv",
    invalidColor: "Sisesta kehtiv heksav\u00E4rv, n\u00E4iteks #ef4129.",
    notifications: "E-posti teavitused",
    pmDigestLabel: "Saada mulle PM-i tegevuse kokkuv\u00F5tte e-kirjad",
    pmDigestDescription:
      "Iga 15 minuti tagant v\u00F5tame kokku uued m\u00E4\u00E4ramised, @-mainimised ja kommentaarid teie teemadel. Eemaldage linnuke, et neid mitte saada.",
    messageBoardLabel: "Saada mulle s\u00F5numitahvli teavitused",
    messageBoardDescription:
      "Saad e-kirja, kui keegi postitab projekti s\u00F5numitahvlile, millele sul on ligip\u00E4\u00E4s. Eemalda linnuke, et neid mitte saada.",
  },
  securitySection: {
    changePassword: "Muuda parooli",
    changePasswordDesc: "Uuendage oma konto parooli, et hoida konto turvalisena.",
    newPassword: "Uus parool",
    newPasswordPlaceholder: "Sisestage uus parool",
    confirmPassword: "Kinnitage parool",
    confirmPasswordPlaceholder: "Kinnitage uus parool",
    updatePassword: "Uuenda parool",
    passwordRequired: "Parool on n\u00F5utav",
    passwordMinLength: "Parool peab olema v\u00E4hemalt 6 t\u00E4hem\u00E4rki",
    passwordMismatch: "Paroolid ei \u00FChti",
    passwordUpdated: "Parool uuendatud",
    passwordUpdatedDesc: "Teie parool on edukalt muudetud.",
    updateFailed: "Uuendamine eba\u00F5nnestus",
    updateFailedDesc: "Parooli uuendamine eba\u00F5nnestus. Palun proovige uuesti.",
    twoFA: "Kaheastmeline autentimine",
    twoFADesc: "Lisage oma kontole kaheastmelise autentimisega t\u00E4iendav turvakiht.",
    twoFAInfo:
      "Kaheastmeline autentimine (2FA) lisab teie kontole t\u00E4iendava turvakihi, n\u00F5udes sisselogimisel kinnituskoodi teie mobiilseadmest.",
    twoFAStatus: "2FA olek",
    twoFANotConfigured: "Seadistamata",
    enable2FA: "Luba 2FA",
    comingSoon: "Varsti tulemas",
    twoFAInDevelopment: "Kaheastmelise autentimise seadistamine on hetkel arenduses.",
  },
  invitations: {
    title: "Organisatsiooni kutsed",
    description: "Hallake organisatsiooni ootel ja saadetud kutseid",
    pageSubtitle: "Ootel kutsed, mis ootavad teie vastust.",
    noPendingDesc: "Kui keegi kutsub teid organisatsiooniga liituma, ilmub kutse siia.",
    inviteUser: "Kutsu kasutaja",
    linkCopied: "Kutse link kopeeritud l\u00F5ikelauale",
    copyLink: "Kopeeri link",
    resend: "Saada uuesti",
    accepted: "Vastu v\u00F5etud",
    expired: "Aegunud",
    pending: "Ootel",
    empty: "\u00DChtegi kutset pole veel saadetud",
    emptyDesc: "Alustage kasutajate kutsumisega oma organisatsiooniga liitumiseks",
    failedLoadInvites: "Kutsete laadimine eba\u00F5nnestus",
    expiresIn: "Aegub {time}",
    expiredAgo: "Aegunud {time}",
    deleteInviteTitle: "Kas kustutada kutse?",
    deleteInviteDescription: "See eemaldab kutse aadressile {email}. Kutse link lakkab töötamast.",
    deleteInviteSuccess: "Kutse kustutatud",
    deleteInviteFailed: "Kutse kustutamine ebaõnnestus",
    acceptedSuccess: "Olete edukalt organisatsiooniga liitunud.",
    acceptFailed: "Kutse vastuv\u00F5tmine eba\u00F5nnestus",
    accept: "N\u00F5ustu",
    decline: "Keeldu",
    declineInviteTitle: "Kas keelduda kutsest?",
    declineInviteDescription:
      "See keeldub kutsest liituda organisatsiooniga {org}. Administraator saab teid hiljem uuesti kutsuda.",
    declinedSuccess: "Kutsest on keeldutud",
    declineFailed: "Kutsest keeldumine eba\u00F5nnestus",
    invited: "Kutsutud",
    invitedBy: "Kutsuja:",
    invitedRelativeBy: "Kutsus {name} {time}",
    invitedByName: "Kutsus {name}",
    moreActions: "Rohkem tegevusi",
    revoke: "T\u00FChista",
    revokeInviteTitle: "Kas t\u00FChistada kutse?",
    revokeInviteDescription:
      "See t\u00FChistab kutse aadressile {email}. Kutse link lakkab t\u00F6\u00F6tamast.",
    revokeInviteSuccess: "Kutse t\u00FChistatud",
    revokeInviteFailed: "Kutse t\u00FChistamine eba\u00F5nnestus",
    clearAllExpired: "Kustuta k\u00F5ik aegunud",
    clearExpiredTitle: "Kas kustutada aegunud kutsed?",
    clearExpiredDescription:
      "See eemaldab k\u00F5ik {count} aegunud kutset. Nende kutselingid on juba t\u00F6\u00F6tamast lakanud.",
    clearExpiredSuccess: "Aegunud kutsed kustutatud",
    clearExpiredPartial: "Kõiki aegunud kutseid ei õnnestunud kustutada",
    clearExpiredFailed: "Aegunud kutsete kustutamine eba\u00F5nnestus",
    inviteDescription: "Saada kutse liituda organisatsiooniga {org}.",
    inviteDescriptionNoOrganisation: "Saada kutse liituda oma organisatsiooniga.",
    emailLabel: "E-posti aadress",
    emailPlaceholder: "kasutaja@example.com",
    rolePlaceholder: "Vali roll",
    cancel: "T\u00FChista",
    send: "Saada kutse",
    sending: "Saatmine\u2026",
    sent: "Kutse saadetud",
    sendFailed: "Kutse loomine eba\u00F5nnestus",
    noOrganisation: "Organisatsiooni pole valitud",
    invalidEmail: "Sisesta kehtiv e-posti aadress",
    chooseRole: "Vali roll",
  },
  roles: {
    userUpdated: "Kasutaja edukalt uuendatud",
    updateError: "Viga",
    updateFailed: "Kasutaja uuendamine ebaõnnestus",
    mustAssignOwner: "M\u00E4\u00E4rake enne enda alandamist teine organisatsiooni omanik",
    errorLoading: "Viga kasutajate laadimisel",
    role: "Roll",
    roleLabels: {
      org_owner: "Omanik",
      org_admin: "Administraator",
      subcontractor: "Liige",
    },
    roleUpdated: "Roll uuendatud: {role}",
    roleUpdateFailed: "Rolli uuendamine eba\u00F5nnestus",
    memberRemoved: "Liige eemaldatud",
    memberRemoveFailed: "Liikme eemaldamine eba\u00F5nnestus",
    removeMemberTitle: "Eemalda liige",
    removeMemberDescription:
      "Eemalda {email} sellest organisatsioonist? Ta kaotab sellele kogu juurdep\u00E4\u00E4su. See ei kustuta tema kontot.",
    buildingAssignments: "Hoonete m\u00E4\u00E4rangud",
    status: "Olek",
    selectRole: "Vali roll",
    roleDescriptions: {
      org_admin:
        "T\u00E4ielik juurdep\u00E4\u00E4s k\u00F5igile projektidele ja organisatsiooni seadetele",
      subcontractor: "Juurdep\u00E4\u00E4s ainult talle antud projektidele",
    },
    selectBuildings: "Vali hooned (valikuline)",
    allBuildings: "K\u00F5ik hooned",
    selectStatus: "Vali olek",
    active: "Aktiivne",
    inactive: "Mitteaktiivne",
    save: "Salvesta",
    refresh: "V\u00E4rskenda",
    manageProjectsTitle: "Halda projektide juurdep\u00E4\u00E4su",
    manageProjectsDescription: "Vali, millistele projektidele {name} ligi p\u00E4\u00E4seb.",
    projectsLabel: "Projektid, millele liikmel on juurdep\u00E4\u00E4s",
    loadingProjects: "Projektide laadimine\u2026",
    projectsLoadFailed: "Projektide laadimine eba\u00f5nnestus.",
    projectsRefreshFailed:
      "Projektide nimekirja v\u00e4rskendamine eba\u00f5nnestus. See v\u00f5ib olla aegunud, seega proovi enne saatmist uuesti.",
    projectsNotLoaded: "Projektide nimekiri alles laeb. Oota selle laadimist ja saada kutse siis.",
    projectNoLongerAvailable:
      "\u00dcks valitud projektidest pole enam saadaval. Kontrolli valikut ja saada uuesti.",
    projectsNoLongerAvailable:
      "{count} valitud projekti pole enam saadaval. Kontrolli valikut ja saada uuesti.",
    projectsNoLongerOfferable:
      "Midagi ei salvestatud. Pole enam saadaval: {projects}. Need m\u00e4rked on eemaldatud \u2014 \u00fclej\u00e4\u00e4nud muudatused on alles, seega salvesta uuesti nende rakendamiseks.",
    projectsChangedElsewhere:
      "Midagi ei salvestatud. Keegi teine muutis selle liikme juurdep\u00e4\u00e4su, kui see aken oli lahti, seega tehti muudatused aegunud nimekirja p\u00f5hjal. Nimekiri on uuesti laaditud \u2014 palun tee muudatused uuesti.",
    projectUnavailable: "arhiveeritud v\u00f5i peidetud",
    folderPositionUnknown: "asukoht teadmata \u2014 v\u00f5ib asuda m\u00f5ne teise kausta all",
    expandItem: "Laienda: {name}",
    collapseItem: "Ahenda: {name}",
    hiddenAssignmentsKept:
      "Tal on juurdep\u00e4\u00e4s ka {count} projektile, mida siin laadida ei \u00f5nnestunud. Salvestamine s\u00e4ilitab selle juurdep\u00e4\u00e4su.",
    noProjects: "Sellel organisatsioonil pole veel projekte.",
    noProjectsForInvite:
      "Sellel organisatsioonil pole veel projekte. Loo projekt enne liikme kutsumist.",
    selectAtLeastOneProject: "Vali liikmele v\u00E4hemalt \u00FCks projekt.",
    projectsUpdated: "Projektide juurdep\u00E4\u00E4s uuendatud",
    projectsUpdateFailed: "Projektide juurdep\u00E4\u00E4su uuendamine eba\u00F5nnestus",
  },
  memberAccess: {
    description:
      "Vali, millistele projektidele {name} ligi p\u00E4\u00E4seb ja mida ta igas neist teha saab.",
    projectsHeading: "Projektid",
    noProjectSelected: "Vali projekt, et m\u00E4\u00E4rata, mida see liige seal teha saab.",
    selectedProjectHint: "Projekti {project} seaded",
    accessLevel: "Juurdep\u00E4\u00E4su tase",
    presets: {
      view: "Ainult vaatamine",
      contributor: "Kaast\u00F6\u00F6taja",
      full: "T\u00E4ielik",
      custom: "Kohandatud",
    },
    presetDescriptions: {
      view: "N\u00E4eb faile, \u00FClesandeid, l\u00E4hte\u00FClesannet ja kontakte ning kasutab joonise- ja mudelivaaturit, kuid ei saa midagi muuta.",
      contributor:
        "Liikme vaikimisi \u00F5igused: saab faile lisada ja muuta ning \u00FClesannetega t\u00F6\u00F6tada.",
      full: "K\u00F5ik, mida liikmele projektis anda saab, sealhulgas j\u00E4\u00E4dav kustutamine.",
      custom: "Allpool valitud kombinatsioon.",
    },
    whatTheyCanDo: "Mida ta teha saab",
    groups: {
      files: "Failid",
      projectManagement: "Projektijuhtimine",
      viewers: "Vaaturid",
      brief: "L\u00E4hte\u00FClesanne",
      contacts: "Kontaktid",
    },
    permissions: {
      ADD_PROJECT_FILES: {
        label: "Faile \u00FCles laadida ja kaustu luua",
        description: "Lisada sellesse projekti dokumente ja uusi kaustu.",
      },
      MODIFY_PROJECT_FILES: {
        label: "Muuta, \u00FCmber nimetada, teisaldada ja pr\u00FCgikasti viia",
        description:
          "Muuta ja \u00FCmber korraldada faile ja kaustu ning viia neid pr\u00FCgikasti.",
      },
      DELETE_PROJECT_FILES: {
        label: "J\u00E4\u00E4davalt kustutada",
        description: "Eemaldada faile ja kaustu pr\u00FCgikastist l\u00F5plikult.",
      },
      VIEW_PM: {
        label: "N\u00E4ha \u00FClesandeid",
        description: "N\u00E4ha selle projekti \u00FClesandeid, ajakava ja tahvlit.",
      },
      MANAGE_PM: {
        label: "Luua ja muuta \u00FClesandeid",
        description: "Lisada, uuendada, \u00FCmber ajastada ja sulgeda \u00FClesandeid.",
      },
      VIEW_DRAWING_COMPARE: {
        label: "Kasutada joonisevaaturit",
        description:
          "Avada selle projekti DWG-jooniseid joonisevaaturis, eraldi v\u00F5i k\u00F5rvuti.",
      },
      USE_MODEL_VIEWER: {
        label: "Kasutada mudelivaaturit",
        description: "Avada selle projekti IFC-mudeleid 3D-mudelivaaturis.",
      },
      VIEW_BRIEFS: {
        label: "N\u00E4ha l\u00E4hte\u00FClesannet",
        description: "Lugeda projekti l\u00E4hte\u00FClesannet ja selle t\u00E4iendusi.",
      },
      MANAGE_BRIEFS: {
        label: "Muuta l\u00E4hte\u00FClesannet",
        description: "Muuta l\u00E4hte\u00FClesannet ja kinnitada selle uusi versioone.",
      },
      VIEW_CONTACTS: {
        label: "N\u00E4ha kontakte",
        description: "N\u00E4ha selle projekti kontaktisikuid ja ettev\u00F5tteid.",
      },
      MANAGE_CONTACTS: {
        label: "Lisada ja muuta kontakte",
        description:
          "Lisada projekti kontakte ning muuta enda sisestatud v\u00F5i teda kirjeldavaid kontakte.",
      },
    },
    requires: "Sisse l\u00FClitamisel l\u00FClitub sisse ka \u201e{permission}\u201c.",
    applyToAll: "Rakenda k\u00F5igile valitud projektidele",
    appliedToAll: "Rakendatud k\u00F5igile valitud projektidele",
    permissionsUnavailable:
      "Liikme \u00F5iguste valimine projektide kaupa pole veel saadaval. Projekte ja kaustu saad siiski valida.",
    permissionsLoadFailed: "Liikme projektide\u00F5iguste laadimine eba\u00F5nnestus.",
  },
  chatbotSettings: {
    title: "Vestlusroboti seaded",
    descriptionLine1:
      "Kui vestlusrobot soovib teie andmeid muuta, k\u00FCsib ta iga kord kinnitust.",
    descriptionLine2:
      "L\u00FClitage t\u00F6\u00F6riist siin sisse, et see alati lubada ja kinnituskaart vahele j\u00E4tta; l\u00FClitage v\u00E4lja, et teilt uuesti k\u00FCsitaks.",
    unavailable: "Vestlusroboti seaded pole saadaval, sest vestlusrobot pole seadistatud.",
    loadError: "Vestlusroboti seadeid ei \u00F5nnestunud laadida. Palun proovige uuesti.",
    updateError: "Vestlusroboti seadet ei \u00F5nnestunud uuendada. Palun proovige uuesti.",
    enableAria: "Luba see tegevus alati",
    disableAria: "K\u00FCsi iga kord kinnitust",
    tools: {
      updateBuildingData: {
        label: "Uuenda hoone andmeid",
        description:
          "Luba vestlusrobotil muuta hoone atribuutide v\u00E4\u00E4rtusi ilma iga kord k\u00FCsimata.",
      },
      createPmIssue: {
        label: "Loo \u00FClesandeid",
        description:
          "Luba vestlusrobotil luua projektijuhtimise \u00FClesandeid ilma iga kord k\u00FCsimata.",
      },
      updatePmIssue: {
        label: "Uuenda \u00FClesandeid",
        description:
          "Luba vestlusrobotil muuta projektijuhtimise \u00FClesandeid ilma iga kord k\u00FCsimata.",
      },
      addPmIssueComment: {
        label: "Kommenteeri \u00FClesandeid",
        description:
          "Luba vestlusrobotil lisada \u00FClesannetele kommentaare ilma iga kord k\u00FCsimata.",
      },
      addFileToFolder: {
        label: "Lisa faile kaustadesse",
        description:
          "Luba vestlusrobotil paigutada dokumente kaustadesse ilma iga kord k\u00FCsimata.",
      },
      setDocumentVerified: {
        label: "Kinnita dokumente",
        description:
          "Luba vestlusrobotil m\u00E4rkida dokumente kinnitatuks ilma iga kord k\u00FCsimata. Kinnitused salvestatakse endiselt sinu nimele.",
      },
    },
  },
};
